import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useBrand } from "../../context/BrandContext";
import { listPublicCareers } from "../../api/recruitment";
import { CareersShell, employmentTypeLabel, apiError } from "./CareersShell";
import "./PublicCareers.css";

export default function PublicCareers() {
  const brand = useBrand();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const rows = await listPublicCareers();
        if (!cancelled) setJobs(Array.isArray(rows) ? rows : []);
      } catch (err) {
        if (!cancelled) {
          setError(
            err?.response?.status === 403
              ? "بوابة التوظيف غير متاحة حالياً"
              : apiError(err, "تعذر تحميل الوظائف"),
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <CareersShell>
      <h1 className="careers-title">وظائف شاغرة</h1>
      <p className="careers-subtitle">
        قدّم مباشرة على الوظائف المفتوحة في {brand.companyName}
      </p>
      {loading && <div className="careers-status">جارٍ التحميل...</div>}
      {error && <div className="careers-error">{error}</div>}
      {!loading && !error && jobs.length === 0 && (
        <div className="careers-status">لا توجد وظائف متاحة للتقديم حالياً.</div>
      )}
      <div className="careers-grid">
        {jobs.map((job) => (
          <Link key={job.id} className="careers-card" to={`/careers/${job.id}`}>
            <h2>{job.title}</h2>
            <p className="careers-meta">
              {[job.department?.name, job.branch?.name, employmentTypeLabel(job.employmentType)]
                .filter(Boolean)
                .join(" · ")}
            </p>
            {job.description ? (
              <p className="careers-snippet">
                {String(job.description).slice(0, 160)}
                {String(job.description).length > 160 ? "…" : ""}
              </p>
            ) : null}
          </Link>
        ))}
      </div>
    </CareersShell>
  );
}
